import React from 'react';
import CalendarDay from '@app/state/calendar/CalendarDay';
import Utilities from '@util/Utilities';
import { PresentationChartLineIcon } from '@heroicons/react/24/solid';

export const MarketStateDailySnapshotTableHeaderFragment: React.FunctionComponent<{
	calendarDay: CalendarDay,
	tooltipId: string,
	setSelectedCalendarDay: (day: CalendarDay) => void,
}> = ({ calendarDay, tooltipId, setSelectedCalendarDay }) => {


	return <th scope="col"
						 className={Utilities.classNames('px-3 py-3.5 text-center text-sm font-semibold', calendarDay.isPast ? 'text-gray-400' : 'text-gray-900', calendarDay.isToday ? 'bg-blue-100 font-semibold text-gray-900' : '')}>
		<a href="#" className="group inline-flex items-center" data-tooltip-id={tooltipId} onClick={() => setSelectedCalendarDay(calendarDay)}>
			{Utilities.formatDate(calendarDay.date, 'ddd DD/MM')}
			<span className="ml-1 flex-none text-gray-500 group-hover:text-blue-500">
				<PresentationChartLineIcon className="w-3.5 h-3.5" />
			</span>
		</a>
	</th>;
};